module.exports = __webpack_public_path__ + "static/img/value-bg.374e7354.png";